import ClockoutController from '../../../../core/clockout.controller';
import Inherit from '../../../../core/inherit';

class SidebarFooterController extends Inherit(ClockoutController) {
    handleSettingsClick = () => {
        if (this.props.navigate) this.props.navigate('/account');
    };

    handleSupportClick = () => {
        this.navigateSupport();
    };

    handleLogoutClick = () => {
        this.logout();
    };
}

export default SidebarFooterController;
